export default __webpack_public_path__ + "static/media/download.31bd9d04.svg";